// Copyright (c) Docugami, Inc. All rights reserved.

// this is the array of token breaking characters that is used when breaking DGML into tokens when matching the tokens returned by
// paragraph.getTextRanges.
export const tokenBreakingCharactersForWordHack: string[] = [
    ' ',
    '\xa0',
    '.',
    ',',
    '”',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\t',
    ':',
    '\'',
    '‘',
    '’',
    '$',
    ';',
    '%',
    '-',
    '\u2002',
];

// this is the array of token breaking characters that is passed to paragraph.getTextRanges, for work to break a paragraph into tokens
export const tokenBreakingCharactersForWord: string[] = [
    ' ',
    '.',
    ',',
    '“',
    '”',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\t',
    ':',
    '\'',
    '‘',
    '’',
    '$',
    ';',
    '%',
    '-',
    '\u2002',
];

// this is the array of characters that we use when breaking both the openxml and the dgml into tokens
// before doing lcs.
export const tokenBreakingCharacters: string[] = [
    '.',
    ',',
    '“',
    '”',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\t',
    ':',
    '\'',
    '‘',
    '’',
    '$',
    ';',
    '%',
    '-',
    '\u2002',
];

export function isTokenBreakingCharacter(ch: string)
{
    return tokenBreakingCharacters.indexOf(ch) !== -1;
}

